function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14 0H2C0.9 0 0 0.9 0 2V10C0 11.1 0.9 12 2 12H5V14H3C2.4 14 2 14.4 2 15C2 15.6 2.4 16 3 16H13C13.6 16 14 15.6 14 15C14 14.4 13.6 14 13 14H11V12H14C15.1 12 16 11.1 16 10V2C16 0.9 15.1 0 14 0ZM9 14H7V12H9V14ZM14 10H2V2H14V10Z",
  fill: "black"
});

function SvgMonitor({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNCAwSDJDMC45IDAgMCAwLjkgMCAyVjEwQzAgMTEuMSAwLjkgMTIgMiAxMkg1VjE0SDNDMi40IDE0IDIgMTQuNCAyIDE1QzIgMTUuNiAyLjQgMTYgMyAxNkgxM0MxMy42IDE2IDE0IDE1LjYgMTQgMTVDMTQgMTQuNCAxMy42IDE0IDEzIDE0SDExVjEySDE0QzE1LjEgMTIgMTYgMTEuMSAxNiAxMFYyQzE2IDAuOSAxNS4xIDAgMTQgMFpNOSAxNEg3VjEySDlWMTRaTTE0IDEwSDJWMkgxNFYxMFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=";
export { SvgMonitor as ReactComponent };